import { ListingPublishStatus } from "./api/schema";
import { SearchTypes } from "../../../constants/filters";
import { CircleCheck, CircleDashed, CircleX } from "lucide-react";
import { ROOM_FEATURE_OPTIONS, HOUSE_FEATURE_OPTIONS } from "@/constants/features";
export function getListingFeaturePills(features?: {
  featureKey: string;
}[] | null) {
  const keys = new Set((features ?? []).map(f => f.featureKey));
  const room = ROOM_FEATURE_OPTIONS.filter(o => keys.has(o.key));
  const house = HOUSE_FEATURE_OPTIONS.filter(o => keys.has(o.key));
  return {
    room,
    house,
    hasAny: room.length > 0 || house.length > 0
  };
}
export const ListingPublishStatusBgColor: Record<ListingPublishStatus, string> = {
  [ListingPublishStatus.DRAFT]: "bg-zinc-300 dark:bg-zinc-600",
  [ListingPublishStatus.ACTIVE]: "bg-emerald-100 dark:bg-emerald-500/15",
  [ListingPublishStatus.INACTIVE]: "bg-red-100 dark:bg-red-500/15"
};
export const ListingPublishStatusHoverBgColor: Record<ListingPublishStatus, string> = {
  [ListingPublishStatus.DRAFT]: "hover:bg-zinc-400! dark:hover:bg-zinc-500!",
  [ListingPublishStatus.ACTIVE]: "hover:bg-emerald-200! dark:hover:bg-emerald-500/25!",
  [ListingPublishStatus.INACTIVE]: "hover:bg-red-200! dark:hover:bg-red-500/25!"
};
export const ListingPublishStatusTextColor: Record<ListingPublishStatus, string> = {
  [ListingPublishStatus.DRAFT]: "text-zinc-700 dark:text-zinc-200",
  [ListingPublishStatus.ACTIVE]: "text-emerald-800 dark:text-emerald-300",
  [ListingPublishStatus.INACTIVE]: "text-red-800 dark:text-red-300"
};
export const ListingBusinessBgTypeColor: Record<SearchTypes, string> = {
  [SearchTypes.AUCTION]: "bg-purple-800",
  [SearchTypes.BUY]: "bg-primary",
  [SearchTypes.RENT]: "bg-green-700",
  [SearchTypes.RENT_ROOM]: "bg-orange-800"
};
export const ListingBusinessRingTypeColor: Record<SearchTypes, string> = {
  [SearchTypes.AUCTION]: "ring-purple-800",
  [SearchTypes.BUY]: "ring-primary",
  [SearchTypes.RENT]: "ring-green-700",
  [SearchTypes.RENT_ROOM]: "ring-orange-800"
};
export const ListingBusinessIcon: Record<ListingPublishStatus, React.ReactNode> = {
  [ListingPublishStatus.DRAFT]: <CircleDashed className="text-gray-300" />,
  [ListingPublishStatus.ACTIVE]: <CircleCheck className="text-emerald-300 " />,
  [ListingPublishStatus.INACTIVE]: <CircleX className="text-red-500 " />
};